import { AddUserButton } from './components/AddUserButton';
import { ChangeUserButton } from './components/ChangeUserButton';
import { RemoveUserButton } from './components/RemoveUserButton';
import { isMobileScreen } from '@apply/ui';

export interface ActionsCellProps {
    propertyId: number;
    userId: string | undefined;
    onRefresh: () => void;
}

export const ActionsCell: React.FC<ActionsCellProps> = ({ propertyId, userId, onRefresh }) => {
    const mobileScreen = isMobileScreen();
    if (!propertyId) {
        return;
    }

    return (
        <>
            {userId && (
                <div style={{ display: 'flex', justifyContent: mobileScreen ? 'flex-end' : 'center' }}>
                    <div style={{ paddingRight: '15px' }}>
                        <ChangeUserButton
                            propertyId={propertyId}
                            userId={userId}
                            onRefresh={onRefresh}
                        />
                    </div>
                    <div>
                        <RemoveUserButton
                            propertyId={propertyId}
                            userId={userId}
                            onRefresh={onRefresh}
                        />
                    </div>
                </div>
            )}
            {!userId && (
                <div style={{ display: 'flex', paddingTop: '1px', justifyContent: mobileScreen ? 'flex-end' : 'center' }}>
                    <AddUserButton
                        propertyId={propertyId}
                        onRefresh={onRefresh}
                    />
                </div>
            )}
        </>
    );
};
